import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import errorMessages from "../../constants/errorMessages";
import { Input } from "../../components/Input";
import { Button } from "../../components/Button";
import { Icon } from "../../assets/icons";

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const { forgotPassword } = useAuth();

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    // Validation
    if (!email.trim()) {
      setError(errorMessages.FORGOT_EMAIL_REQUIRED.ja);
      setIsLoading(false);
      return;
    }

    // Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError(errorMessages.FORGOT_EMAIL_FORMAT.ja);
      setIsLoading(false);
      return;
    }

    try {
      // Use AuthContext method
      const result = await forgotPassword(email);

      if (result.success) {
        // Success - navigate to email sent page
        navigate("/forgot-password-sent", { state: { email } });
      } else {
        setError(result.message);
      }
    } catch (err) {
      setError(errorMessages.FORGOT_EMAIL_NOT_EXIST.ja);
    } finally {
      setIsLoading(false);
    }
  };

  const handleReturnToLogin = () => {
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-0">
      <div className="w-full max-w-[600px] mx-auto px-8 py-12">
        <div className="w-full space-y-2">
          <form onSubmit={handleSubmit} className="space-y-10">
            <h2 className="text-2xl font-bold text-center leading-9">
              パスワード忘れ?
            </h2>
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded mb-4">
                {error}
              </div>
            )}
            <div className="space-y-2">
              <Input
                type="text"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value?.trim())}
                placeholder="test@gmail.com"
                disabled={isLoading}
                label="メールアドレス"
                className="w-full h-14 placeholder:text-base"
              />
              <p className="text-xs text-center leading-4.5 whitespace-nowrap overflow-hidden text-ellipsis">
                パスワード再設定用のリンクをメールアドレスに送信しますので、正しく入力してください。
              </p>
            </div>
            <Button
              type="submit"
              buttonType="primary"
              className="text-sm-plus px-4 py-2.5 !h-12 mb-6 mx-auto"
              disabled={isLoading}
              isLoading={isLoading}
            >
              <span className="flex items-center justify-center gap-2 text-white">
                送信 <Icon name={"plane"} />
              </span>
            </Button>
          </form>
          <Button
            type="button"
            buttonType="link"
            disabled={isLoading}
            className="!h-12 mx-auto text-sm-plus text-cyan"
            onClick={handleReturnToLogin}
          >
            ログイン画面へ戻る
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
